import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ICopyLinkedValuesBehavior } from "../../../../documaker/domain/format/objects";

export interface ICopyLinkedTextsBehaviorPropertyEditable {
  copyLinkedTextsBehavior(): IPropertyEditable<ICopyLinkedValuesBehavior>;
}

export function instanceOfICopyLinkedTextsBehaviorPropertyEditable(instance: any): instance is ICopyLinkedTextsBehaviorPropertyEditable {
  return instance
      && instance.copyLinkedTextsBehavior
      && instanceOfIPropertyEditable<ICopyLinkedValuesBehavior>(instance.copyLinkedTextsBehavior());
}
